import {Injectable} from '@angular/core';
import {PermissionService} from '../permission.service';
import {AppointmentPermissionEnum} from '../../../../shared/enums/permission.enum';

@Injectable({
  providedIn: 'root'
})
export class CcPermissionsService {

  constructor(private permission: PermissionService) {
  }

  canBookInPast(): boolean {
    return this.permission
      .hasPermission(AppointmentPermissionEnum.APPOINTMENT_CREATE_IN_THE_PAST);
  }

  canBookAppointment(): boolean {
    return this.permission
      .hasPermission(AppointmentPermissionEnum.APPOINTMENT_CREATE_ALL);
  }

}
